import { Div, Collection, Button } from '@tblabs/truffle';
import { Icons } from '../Utils/Icons';


export class Swaper<T> extends Div
{
    constructor(collection: Collection<T>, item: T)
    {
        super("swaper");

        this.Append(
            collection.CanSwapUp(item) && new Button(Icons.Up).OnClick(() => collection.SwapUp(item)),
            collection.CanSwapDown(item) && new Button(Icons.Down).OnClick(() => collection.SwapDown(item)),
            new Button(Icons.Delete).OnClick(() => collection.Remove(item)),
        );
    }
}
